import { DocumentsContext } from 'Context/DocumentsContext';
import { useContext } from 'react';
import { AccordionDocument } from '../AccordionDocument';
import { useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Stack } from '@mui/material';

export const CurrentYearDocuments = () => {
  const { documents, filter } = useContext(DocumentsContext);

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Documents
  ).timePeriods;

  const getOrderedArray = (arr: any[], isDescending: boolean) =>
    isDescending ? arr : arr.reverse();

  const transformedTimePeriods = [
    dictionary.today,
    dictionary.thisWeek,
    dictionary.thisMonth,
    dictionary.thisYear,
  ];
  const transformedDocumentsResults = Object.entries(documents.results).map(
    ([category, docs]) => ({
      category,
      docs,
    })
  );

  const timePeriods = getOrderedArray(
    transformedTimePeriods,
    filter.orderByDescending
  );
  const currentYearDocuments = getOrderedArray(
    transformedDocumentsResults,
    filter.orderByDescending
  );

  return (
    <Stack gap='40px'>
      {currentYearDocuments.map((result, index: number) => {
        if (result.docs.length > 0)
          return (
            <AccordionDocument
              key={index}
              time={timePeriods[index]}
              documents={result.docs}
              openOnRender
            />
          );
        return null;
      })}
    </Stack>
  );
};
